import React, { useContext } from 'react';

import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SpendCubeSettingsContext } from 'contexts/SpendCubeSettingsContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import {
	convertToArray,
	isCustomCategory,
	getCurrencySymbolFromOptions,
} from 'Details/utils';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';
import numeral from 'numeral';
import {
	getTopVendors,
	getInitiativeItemTopVendors,
	getInitiativeTopVendors,
} from 'utils/apiRequests';
import {
	TableWrapper,
	StyledModal,
	HeaderCell,
	HeaderCellNumber,
	Cell,
	CellNumber,
	Row,
	Text,
	Title,
	LoadingContainer,
} from './TopVendorsModal.styles';
const blankName = '(Blank)';

export class TopVendorsModal extends React.Component {
	state = { data: null };

	getApiParams = () => {
		const {
			currency,
			dateFrom,
			dateTo,
			extraFilters,
			storedQueryId,
			showNonSourceable,
			customFiltersValues,
			customFilters,
			includeCustomCategories = false,
			isPmi,
			hierarchy,
			getTailSpendOnly,
			includeTailSpend,
			useNetSpend,
			waterfallFilter,
			isHarmonized,
			isTailSpend,
			spendType,
			indirectTaxonomy,
			directTaxonomy,
			topVendorsModalDataId,
			name,
		} = this.props;
		const params = {
			currencyType: 'fixed',
			useNetSpend,
			currency,
			dateFrom,
			dateTo,
			includeCustomCategories,
			getTailSpendOnly: getTailSpendOnly || isTailSpend,
			includeTailSpend,
		};

		params.filters = ['sourceable'];
		params.filterValues = [showNonSourceable !== 'true'];

		if (!isPmi) {
			params.harmonized = isHarmonized;
			params.includeCustomCategories = includeCustomCategories;
			params.filters = [
				...params.filters,
				...(waterfallFilter ? [waterfallFilter[0]] : []),
			];
			params.filterValues = [
				...params.filterValues,
				...(waterfallFilter ? [waterfallFilter[1]] : []),
			];
		} else {
			params.harmonized = true;
		}

		if (customFiltersValues.length > 0) {
			params.filters = [...params.filters, ...customFilters];
			params.filterValues = [...params.filterValues, ...customFiltersValues];
		}

		if (extraFilters) {
			const filterObj = Object.keys(extraFilters).reduce(
				(acc, filterName) => {
					return {
						...acc,
						filters: [
							...acc.filters,
							...new Array(extraFilters[filterName].length).fill(filterName),
						],
						filterValues: [...acc.filterValues, ...extraFilters[filterName]],
					};
				},
				{
					filters: [],
					filterValues: [],
				}
			);

			params.filters = [...params.filters, ...filterObj.filters];
			params.filterValues = [...params.filterValues, ...filterObj.filterValues];
		}

		params.filters = [...params.filters, 'SpendType'];

		if (topVendorsModalDataId) {
			let isDirect;
			if (topVendorsModalDataId.startsWith('Direct')) {
				isDirect = true;
			} else if (topVendorsModalDataId.startsWith('Indirect')) {
				isDirect = false;
			} else {
				console.warn('Does not start with Direct or Indirect');
			}

			if (isDirect === false) {
				params.filterValues = [...params.filterValues, 1];
			} else if (isDirect === true) {
				params.filterValues = [...params.filterValues, 0];
				if (
					(directTaxonomy === '2' && indirectTaxonomy === '2') ||
					typeof spendType === 'undefined'
				) {
					params.includeCustomCategories = true;
				}
			}
			if (hierarchy) {
				params.hierarchy = hierarchy;
			}
		} else {
			if (typeof spendType !== 'undefined') {
				if (spendType !== '0') {
					params.filterValues = [...params.filterValues, 1];
				} else if (spendType === '0') {
					params.filterValues = [...params.filterValues, 0];
					if (directTaxonomy === '2' && indirectTaxonomy === '2') {
						params.includeCustomCategories = true;
					}
				}

				const stringFilterValues = params.filterValues.filter(
					value => typeof value === 'string'
				);
				params.hierarchy = [...(hierarchy || []), ...stringFilterValues];
			} else if (name === 'Indirect') {
				params.filterValues = [...params.filterValues, 1];
			} else if (name === 'Direct') {
				params.filterValues = [...params.filterValues, 0];
				params.includeCustomCategories = true;
			}
		}

		if (storedQueryId) {
			params.storedQueryId = storedQueryId;
		}

		return params;
	};
	componentDidMount() {
		this.fetchData();
	}
	fetchData = () => {
		const { initiativeParams } = this.props;
		const request = initiativeParams
			? initiativeParams.initiativeId
				? getInitiativeTopVendors(initiativeParams.initiativeId)
				: getInitiativeItemTopVendors(initiativeParams)
			: getTopVendors(this.getApiParams());

		return request.then(data => {
			this.setState({ data });
		});
	};
	spendFormatter = value => {
		const { currencySymbol, hideDecimals } = this.props;

		return value
			? formatSpendWithDecimalAndSymbol(
					value,
					currencySymbol,
					hideDecimals,
					2
			  ).toUpperCase()
			: '-';
	};

	render() {
		const { onClose, name } = this.props;
		const { data } = this.state;

		return (
			<StyledModal
				isOpen={true}
				header="Top vendors"
				isDismissible
				hasClosed={onClose}
			>
				<TableWrapper>
					<Title>{name || blankName}</Title>
					{!data ? (
						<LoadingContainer>
							<ApLoaderDefault loaderText={() => <ApLoaderText />} />
						</LoadingContainer>
					) : (
						<React.Fragment>
							<Row>
								<HeaderCell>
									<Text>Rank</Text>
								</HeaderCell>
								<HeaderCell>
									<Text>Vendor name</Text>
								</HeaderCell>
								<HeaderCellNumber>Spend</HeaderCellNumber>
								<HeaderCellNumber>Transactions</HeaderCellNumber>
							</Row>
							{data.map(({ vendorName, spend, transactionsCount }, index) => (
								<Row key={index}>
									<Cell>
										<Text bold>{index + 1}</Text>
									</Cell>
									<Cell>
										<Text>{vendorName}</Text>
									</Cell>
									<CellNumber>{this.spendFormatter(spend)}</CellNumber>
									<CellNumber>
										{numeral(transactionsCount).format('0,0')}
									</CellNumber>
								</Row>
							))}
						</React.Fragment>
					)}
				</TableWrapper>
			</StyledModal>
		);
	}
}

export default props => {
	const {
		currency,
		customFilters,
		customFiltersValues,
		waterfallFilter,
		dateFrom,
		dateTo,
		measures,
		showNonSourceable,
		dimensions,
		storedQueryId,
		showHarmonizedVendors,
		isTailSpend,
		hideDecimals,
		spendType,
		indirectTaxonomy,
		directTaxonomy,
	} = useContext(QueryStringContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const { settings } = useContext(SpendCubeSettingsContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const useNetSpend =
		settings && settings.tailSpend ? settings.tailSpend.useNetSpend : true;

	return (
		<TopVendorsModal
			dateFrom={dateFrom}
			dimensions={dimensions}
			dateTo={dateTo}
			customFilters={convertToArray(customFilters)}
			customFiltersValues={convertToArray(customFiltersValues)}
			waterfallFilter={waterfallFilter}
			hierarchy={measures}
			hideDecimals={hideDecimals}
			isHarmonized={showHarmonizedVendors === 'true'}
			isTailSpend={isTailSpend === 'true'}
			showNonSourceable={showNonSourceable}
			includeCustomCategories={isCustomCategory(dimensions)}
			storedQueryId={storedQueryId}
			currencySymbol={currencySymbol}
			currency={currency}
			useNetSpend={useNetSpend}
			spendType={spendType}
			indirectTaxonomy={indirectTaxonomy}
			directTaxonomy={directTaxonomy}
			{...props}
		/>
	);
};
